import { getContrast } from 'polished';
import brandColors from './brandColors';

export default function readableColor(color: string) {
  return getContrast(color, brandColors.common.white) > getContrast(color, brandColors.common.black)
    ? brandColors.common.white
    : brandColors.common.black;
}
